import '../scss/campaign.scss';

$('.mv-slids').slick({
  prevArrow: '<img src="/common/img/fanclub/20221014/icon_arrow_slide_left.svg" class="slide-arrow prev-arrow slick-prev">',
  nextArrow: '<img src="/common/img/fanclub/20221014/icon_arrow_slide_right.svg" class="slide-arrow next-arrow slick-next">',
  dots: true,
  appendDots: $('.slids-dots-mv'),
  autoplay: true
});

//ヨドコウ
let yodokoCameraUrl = [
  '/campaign/2024/advertisement/360view/sakura/ss_main_north_premire.html',//9
  '/campaign/2024/advertisement/360view/sakura/ss_main_south_premire.html',//10
  '/campaign/2024/advertisement/360view/sakura/ss_main_north_ex.html',//11
  '/campaign/2024/advertisement/360view/sakura/ss_main_south_ex.html',//12
  '/campaign/2024/advertisement/360view/sakura/ss_main_row13.html',//14
  '/campaign/2024/advertisement/360view/sakura/s_back_row30.html',//3
  '/campaign/2024/advertisement/360view/sakura/s_back_row10.html',//4
  '/campaign/2024/advertisement/360view/sakura/s_main_north_row10.html',//13
  '/campaign/2024/advertisement/360view/sakura/s_main_south_row10.html',//15
  '/campaign/2024/advertisement/360view/sakura/a_main_row24.html',//16
  '/campaign/2024/advertisement/360view/sakura/a_back_north_row30.html',//1
  '/campaign/2024/advertisement/360view/sakura/a_back_north_row10.html',//2
  '/campaign/2024/advertisement/360view/sakura/a_back_south_row30.html',//5
  '/campaign/2024/advertisement/360view/sakura/a_back_south_row10.html',//6
  '/campaign/2024/advertisement/360view/sakura/north_row11.html',//7
  '/campaign/2024/advertisement/360view/sakura/north_row1.html',//8
  '/campaign/2024/advertisement/360view/sakura/south.html'//17
];
let yodokoCameraCls = [
  'stadium-camera--yodoko-ex1-1',//9
  'stadium-camera--yodoko-ex1-2',//10
  'stadium-camera--yodoko-ex2-1',//11
  'stadium-camera--yodoko-ex2-2',//12
  'stadium-camera--yodoko-ss',//14
  'stadium-camera--yodoko-s-1',//3
  'stadium-camera--yodoko-s-2',//4
  'stadium-camera--yodoko-s-3',//13
  'stadium-camera--yodoko-s-4',//15
  'stadium-camera--yodoko-a-main',//16
  'stadium-camera--yodoko-a-back-1-1',//1
  'stadium-camera--yodoko-a-back-1-2',//2
  'stadium-camera--yodoko-a-back-2-1',//5
  'stadium-camera--yodoko-a-back-2-2',//6
  'stadium-camera--yodoko-b-1',//7
  'stadium-camera--yodoko-b-2',//8
  'stadium-camera--yodoko-b-3',//17
];

for(let i = 0;i < yodokoCameraUrl.length;i++){
  $('<a class="stadium-camera stadium-camera-pc"><img src="/common/img/campaign/img_camera.png" alt=""></a><a class="stadium-camera stadium-camera-sp"><img src="/common/img/campaign/img_camera.png" alt=""></a>').attr('href',yodokoCameraUrl[i]).addClass(yodokoCameraCls[i]).insertBefore('.map-img-yodoko');
};

$('.stadium-camera-pc').magnificPopup({
  type: 'iframe',
  removalDelay: 200,
});

$(window).on('load', function(){
  const ua = navigator.userAgent;
  if (ua.indexOf('iPhone') > -1 || (ua.indexOf('Android') > -1 && ua.indexOf('Mobile') > -1)) {
      $('.sp-return-btn').addClass('is-active');
  } else if (ua.indexOf('iPad') > -1 || ua.indexOf('Android') > -1) {
      $('.sp-return-btn').addClass('is-active');
  } else {
      $('.sp-return-btn').removeClass('is-active');
  }
});

let fixedClose = $('.fixed-close');
fixedClose.on('click', function() {
  $('.wrapper__inner').remove();
});

$('.icoTicket_close').on('click', function() {
  $('.icoTicket').remove();
});


const targetDate = new Date('2025-04-12T12:00:00+09:00').getTime();

function updateCountdown() {
  const countdownElement = document.getElementById('countdown');
  
  // 🚨 countdown要素が存在しない場合は処理しない
  if (!countdownElement) {
    clearInterval(countdownInterval);
    return;
  }

  const now = new Date().getTime(); // 現在時刻
  const timeLeft = targetDate - now;

  if (timeLeft <= 0) {
    countdownElement.innerHTML = 'キックオフまで 00日 00時間 00分 00秒';
    clearInterval(countdownInterval);
    return;
  }

  // ✅ 日、時間、分、秒の計算
  const days = String(Math.floor(timeLeft / (1000 * 60 * 60 * 24))).padStart(2, '0');
  const hours = String(Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0');
  const minutes = String(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
  const seconds = String(Math.floor((timeLeft % (1000 * 60)) / 1000)).padStart(2, '0');

  // 🎯 「キックオフまで 24日 08時間 29分 46秒」形式で出力
  countdownElement.innerHTML = `${days}日 ${hours}時間 ${minutes}分 ${seconds}秒`;
}

// 🎉 countdown要素があるときのみ初回実行
if (document.getElementById('countdown')) {
  updateCountdown();
  var countdownInterval = setInterval(updateCountdown, 1000);
}
